export interface Artikel {
  id: number;
  nummer: string;
  artbez1: string;
  artbez2: string;
  artbez3: string;
  artbez4: string;
  artbez5: string;
  beschreibung?: string;
  palettenArtikel?: boolean;
  lplfuehrung?: boolean;
}
